import './drinksonme/style';
import FormStructure from './drinksonme/form_structure';

export default FormStructure;